// extracted by mini-css-extract-plugin
export default {"createThreadButton":"CreateThreadButton_createThreadButton__Z27sg","paged":"CreateThreadButton_paged__BAaeI","pageless":"CreateThreadButton_pageless__Sj0Wq"};